export default __webpack_public_path__ + "static/media/about-bg-shape.a9679465.png";